import { render, staticRenderFns } from "./DeliveryAchievementWidget.vue?vue&type=template&id=2b14bc01&scoped=true&"
import script from "./DeliveryAchievementWidget.vue?vue&type=script&lang=js&"
export * from "./DeliveryAchievementWidget.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAchievementWidget.vue?vue&type=style&index=0&id=2b14bc01&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b14bc01",
  null
  
)

export default component.exports